/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentFieldSetGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Field Set Group API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Wednesday, March 06, 2019 - 12:39 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      03/06/2018  NJN     File Created
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const FieldSetGroups = {
    all: (parentid) => requests.get(`/FieldSetGroups?parentid=${parentid}`),
    get: fieldsetgroupid => requests.get(`/FieldSetGroup/${fieldsetgroupid}`),
    getByName: fieldsetgroup => requests.get(`/FieldSetGroupByName`, fieldsetgroup),
    create: fieldsetgroup => requests.post(`/FieldSetGroups`, fieldsetgroup),
    update: (fieldsetgroupid, fieldsetgroup) => requests.put(`/FieldSetGroup/${fieldsetgroupid}`, fieldsetgroup),
    delete: (fieldsetgroupid, parentid) => requests.del(`/FieldSetGroup/${fieldsetgroupid}?parentid=${parentid}`),
};

export const FieldSetGroupPath = {
    get: parentid => requests.get(`/FieldSetGroupPath/${parentid}`)
};

export const FieldSetGroupTree = {
    get: parentid => requests.get(`/FieldSetGroupTree/${parentid}`)
};

export const FieldSets = {
    all: (fieldsetgroupid) => requests.get(`/FieldSets?fieldsetgroupid=${fieldsetgroupid}`),
    get: fieldsetid => requests.get(`/FieldSet/${fieldsetid}`),
    create: fieldset => requests.post(`/FieldSets`, fieldset),
    update: (fieldsetid, fieldset) => requests.put(`/FieldSet/${fieldsetid}`, fieldset),
    delete: fieldsetid => requests.del(`/FieldSet/${fieldsetid}`),
};

export const Fields = {
    all: (fieldsetgroupid, fieldsetid) => requests.get(`/Fields?fieldsetgroupid=${fieldsetgroupid}&fieldsetid=${fieldsetid}`),
    get: fieldid => requests.get(`/Field/${fieldid}`),
    create: field => requests.post(`/Fields`, field),
    update: (fieldid, field) => requests.put(`/Field/${fieldid}`, field),
    delete: (fieldid, fieldsetid) => requests.del(`/Field/${fieldid}?fieldsetid=${fieldsetid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentFieldSetGroups.js